/**
 * Insurance display name helpers
 *
 * Normalizes insurer labels from catalog documents for headings and templates.
 */

import type { Insurance } from '@physiofit-digital/physiofit_types';

/**
 * Prefer `label`, then `name`; strip “(privat)” variants for display.
 *
 * @param {Object} insurance Insurer catalog row.
 * @return {string} Trimmed display name.
 */
export function displayInsuranceName(insurance: Insurance): string {
  const source = insurance.label?.trim() ? insurance.label : insurance.name;
  const raw = source
    .replace(/\s*\(\s*privat\s*\)\s*/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return raw.length > 0 ? raw : insurance.name.trim();
}

/**
 * Prefer `shortName`; fall back to `label` when short name is missing.
 *
 * @param {Object} insurance Insurer catalog row.
 * @return {string} Short or label display string.
 */
export function displayInsuranceShortName(insurance: Insurance): string {
  const shortName = insurance.shortName?.trim();
  if (shortName) {
    return shortName;
  }
  return insurance.label?.trim() ?? '';
}
